/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _text_with_select_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'gender',
            options: {
                male: { value: [{ type: 0, value: 'Il' }] },
                female: { value: [{ type: 0, value: 'Elle' }] },
                other: { value: [{ type: 0, value: 'Ils' }] },
            },
        },
        { type: 0, value: ' va répondre bientôt.' },
    ],
    'fr',
);

const _text_with_select_en = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'gender',
            options: {
                male: { value: [{ type: 0, value: 'He' }] },
                female: { value: [{ type: 0, value: 'She' }] },
                other: { value: [{ type: 0, value: 'They' }] },
            },
        },
        { type: 0, value: ' will respond shortly.' },
    ],
    'en',
);

export function text_with_select(
    args: { gender: 'female' | 'male' | number | string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _text_with_select_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _text_with_select_en.format(args) as unknown as string;
    }

    return _text_with_select_fr.format(args) as unknown as string;
}

const _simple_text_fr = new IntlMessageFormat([{ type: 0, value: 'Test fr' }], 'fr');

const _simple_text_en = new IntlMessageFormat([{ type: 0, value: 'Test en' }], 'en');

export function simple_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _simple_text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _simple_text_en.format(args) as unknown as string;
    }

    return _simple_text_fr.format(args) as unknown as string;
}

const _text_with_param_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Salut ' },
        { type: 1, value: 'name' },
    ],
    'fr',
);

const _text_with_param_en = new IntlMessageFormat(
    [
        { type: 0, value: 'Hello ' },
        { type: 1, value: 'name' },
    ],
    'en',
);

export function text_with_param(args: { name: string }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _text_with_param_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _text_with_param_en.format(args) as unknown as string;
    }

    return _text_with_param_fr.format(args) as unknown as string;
}

const _text_with_plural_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Panier: "' },
        { type: 1, value: 'itemCount' },
        { type: 0, value: '" ' },
        {
            type: 6,
            value: 'itemCount',
            options: {
                one: { value: [{ type: 0, value: 'article' }] },
                other: { value: [{ type: 0, value: 'articles' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _text_with_plural_en = new IntlMessageFormat(
    [
        { type: 0, value: 'Cart: "' },
        { type: 1, value: 'itemCount' },
        { type: 0, value: '" ' },
        {
            type: 6,
            value: 'itemCount',
            options: {
                one: { value: [{ type: 0, value: 'item' }] },
                other: { value: [{ type: 0, value: 'items' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function text_with_plural(args: { itemCount: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _text_with_plural_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _text_with_plural_en.format(args) as unknown as string;
    }

    return _text_with_plural_fr.format(args) as unknown as string;
}

const _text_with_date_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Date de début ' },
        { type: 3, value: 'startDate', style: 'medium' },
    ],
    'fr',
);

const _text_with_date_en = new IntlMessageFormat(
    [
        { type: 0, value: 'Date of start ' },
        { type: 3, value: 'startDate', style: 'medium' },
    ],
    'en',
);

export function text_with_date(args: { startDate: Date }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _text_with_date_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _text_with_date_en.format(args) as unknown as string;
    }

    return _text_with_date_fr.format(args) as unknown as string;
}

const _text_no_en_fr = new IntlMessageFormat([{ type: 0, value: 'Test fr' }], 'fr');

export function text_no_en(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _text_no_en_fr.format(args) as unknown as string;
    }

    return _text_no_en_fr.format(args) as unknown as string;
}

const _text_with_plural_children_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                '=0': {
                    value: [
                        { type: 1, value: 'userName' },
                        { type: 0, value: ' a réagi ' },
                        {
                            type: 5,
                            value: 'companyName',
                            options: {
                                __null: { value: [{ type: 0, value: 'à votre post' }] },
                                other: {
                                    value: [
                                        { type: 0, value: 'au post de votre société ' },
                                        { type: 1, value: 'companyName' },
                                    ],
                                },
                            },
                        },
                    ],
                },
                '=1': {
                    value: [
                        { type: 1, value: 'userName' },
                        { type: 0, value: ' et une autre personne ont réagi ' },
                        {
                            type: 5,
                            value: 'companyName',
                            options: {
                                __null: { value: [{ type: 0, value: 'à votre post' }] },
                                other: {
                                    value: [
                                        { type: 0, value: 'au post de votre société ' },
                                        { type: 1, value: 'companyName' },
                                    ],
                                },
                            },
                        },
                    ],
                },
                other: {
                    value: [
                        { type: 1, value: 'userName' },
                        { type: 0, value: ' et ' },
                        { type: 7 },
                        { type: 0, value: ' autres personnes ont réagi ' },
                        {
                            type: 5,
                            value: 'companyName',
                            options: {
                                __null: { value: [{ type: 0, value: 'à votre post' }] },
                                other: {
                                    value: [
                                        { type: 0, value: 'au post de votre société ' },
                                        { type: 1, value: 'companyName' },
                                    ],
                                },
                            },
                        },
                    ],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function text_with_plural_children(
    args: { count: number; userName: string; companyName: '__null' | number | string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _text_with_plural_children_fr.format(args) as unknown as string;
    }

    return _text_with_plural_children_fr.format(args) as unknown as string;
}

const _text_with_complex_children_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'gender',
            options: {
                female: {
                    value: [
                        {
                            type: 6,
                            value: 'count',
                            options: {
                                '=0': {
                                    value: [{ type: 0, value: "Elle n'a aucun message" }],
                                },
                                one: { value: [{ type: 0, value: 'Elle a un message' }] },
                                other: {
                                    value: [
                                        { type: 0, value: 'Elle a ' },
                                        { type: 7 },
                                        { type: 0, value: ' messages' },
                                    ],
                                },
                            },
                            offset: 0,
                            pluralType: 'cardinal',
                        },
                    ],
                },
                male: {
                    value: [
                        {
                            type: 6,
                            value: 'count',
                            options: {
                                '=0': {
                                    value: [{ type: 0, value: "Il n'a aucun message" }],
                                },
                                one: { value: [{ type: 0, value: 'Il a un message' }] },
                                other: {
                                    value: [
                                        { type: 0, value: 'Il a ' },
                                        { type: 7 },
                                        { type: 0, value: ' messages' },
                                    ],
                                },
                            },
                            offset: 0,
                            pluralType: 'cardinal',
                        },
                    ],
                },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function text_with_complex_children(
    args: { gender: 'female' | 'male'; count: number },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _text_with_complex_children_fr.format(args) as unknown as string;
    }

    return _text_with_complex_children_fr.format(args) as unknown as string;
}

const _text_no_fr_en = new IntlMessageFormat([{ type: 0, value: 'Test en' }], 'en');

export function text_no_fr(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('en')) {
        return _text_no_fr_en.format(args) as unknown as string;
    }

    return 'text_no_fr' as unknown as string;
}
